import React, { FC } from 'react';
import { KeyContainer } from '../developers/KeyContainer';
import { useApiClientContext } from '../../store/api-client-context';


export const CustomKeyDetailsSecretKeysSection: FC = () => {
	const { apiClientContextState: { apiClientKeysDetails }} = useApiClientContext();

	return (
		<div className="col-xl-6">
			<KeyContainer
				value={apiClientKeysDetails?.key}
				title="Api Key"
				canCopy
				copyWithText
				additionalCopyClass="ms-3"
			/>

			<KeyContainer
				value={apiClientKeysDetails?.value}
				title="Token"
				isVisible
				canCopy
				showPass
				copyWithText
				additionalCopyClass="ms-3"
			/>
		</div>
	);
};
